import { ReduceStore } from 'flux/utils';
import Dispatcher from './../Dispatcher';
import ActionTypes from './ActionTypes';
import ReportManager from './ReportManager';

function formatError(message) {
  return {
    message,
  };
}

class ReportStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {
      loading: false,
      error: null,
      data: [],
    };
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.REPORT_STORE_FETCH:
        ReportManager.fetch(action.parentType, action.parentId);

        return {
          loading: true,
          error: null,
          data: [],
        };

      case ActionTypes.REPORT_STORE_FETCH_COMPLETE:
        return {
          loading: false,
          error: null,
          data: action.data,
        };

      case ActionTypes.REPORT_STORE_FETCH_ERROR:
        return {
          loading: false,
          error: formatError(action.error),
          data: [],
        };

      default:
        return state;
    }
  }
}

export default new ReportStore();
